import { useNavigate } from "react-router-dom";
import { auth, db } from "../Firebase";
import { doc, updateDoc } from "firebase/firestore";
import "../styles/Teacher.css";

const Teacher = () => {
  const navigate = useNavigate();

  const handleGetStarted = async () => {
    const user = auth.currentUser;

    if (!user) {
      alert("Please login first");
      navigate("/login");
      return;
    }

    try {
      //  Save Firebase token
      const token = await user.getIdToken();
      localStorage.setItem("token", token);

      //  Update role to teacher
      await updateDoc(doc(db, "users", user.uid), {
        role: "teacher"
      });

      //  Redirect
      navigate("/teacherCourse");
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }
  };

  return (
    <section className="teacher-hero">
      <div className="teacher-content">
        <h1>
          Come teach <br /> with us
        </h1>

        <p>
          Become an instructor and change lives <br />
          — including your own
        </p>

        <button className="teacher-btn" onClick={handleGetStarted}>
          Get started
        </button>
      </div>

      <div className="teacher-image">
        <img
          src="/images/get-started-teacher.png"
          alt="Become an instructor"
        />
      </div>
    </section>
  );
};

export default Teacher;
